import * as React from "react"
import { cn } from "../../lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, onChange, value, ...props }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (type === "number") {
        const value = e.target.value;
        
        // Allow empty values
        if (value === '') {
          // Call the original onChange for empty value
          if (onChange) {
            onChange(e);
          }
          return;
        }
        
        // Remove leading zeros except for single zero or decimal numbers
        if (value.length > 1 && value.startsWith('0') && !value.startsWith('0.')) {
          const cleanValue = value.replace(/^0+/, '');
          if (cleanValue === '') {
            e.target.value = '0';
          } else {
            e.target.value = cleanValue;
          }
        }
        
        // Prevent multiple decimal points
        const decimalCount = (value.match(/\./g) || []).length;
        if (decimalCount > 1) {
          return;
        }
      }
      
      // Call the original onChange if provided
      if (onChange) {
        onChange(e);
      }
    };

    // Convert null/undefined values to empty string for display
    const displayValue = value === null || value === undefined ? '' : value;

    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          // Add number input spinner styles for web browsers and tablets
          type === "number1" && "[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:bg-[url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20fill%3D%22%23666%22%20d%3D%22M10%2010l-5%205h10z%22/%3E%3C/svg%3E')] [&::-webkit-inner-spin-button]:bg-[url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20fill%3D%22%23666%22%20d%3D%22M10%2015l5-5H5z%22/%3E%3C/svg%3E')] [&::-webkit-outer-spin-button]:bg-no-repeat [&::-webkit-inner-spin-button]:bg-no-repeat [&::-webkit-outer-spin-button]:bg-center [&::-webkit-inner-spin-button]:bg-center [&::-webkit-outer-spin-button]:w-5 [&::-webkit-inner-spin-button]:w-5 [&::-webkit-outer-spin-button]:h-5 [&::-webkit-inner-spin-button]:h-5 [&::-webkit-outer-spin-button]:border-l [&::-webkit-inner-spin-button]:border-l [&::-webkit-outer-spin-button]:border-gray-300 [&::-webkit-inner-spin-button]:border-gray-300 [&::-webkit-outer-spin-button]:bg-gray-50 [&::-webkit-inner-spin-button]:bg-gray-50 hover:[&::-webkit-outer-spin-button]:bg-gray-100 hover:[&::-webkit-inner-spin-button]:bg-gray-100",
          className
        )}
        ref={ref}
        value={displayValue}
        onChange={handleChange}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input } 